import { render, staticRenderFns } from "./InsuranceCompanyServiceEdit.vue?vue&type=template&id=222dfe75&scoped=true&"
import script from "./InsuranceCompanyServiceEdit.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyServiceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222dfe75",
  null
  
)

export default component.exports